var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilterConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './filter/filter'; // force import for JsonSchema
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult } from './validation/toolValidationResult';
const schema = {
    $id: 'urn:wisepipe-common-pipe:FilterConfig',
    type: 'object',
    properties: {
        filter: { $ref: 'urn:wisepipe-common-pipe:Filter' }
    },
    required: ['filter']
};
let FilterConfig = FilterConfig_1 = class FilterConfig extends ToolConfig {
    constructor(filter, customFormats) {
        super(ToolType.FILTER, customFormats);
        this.filter = filter;
        JSON.validate(this, FilterConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return FilterConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return FilterConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return FilterConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return FilterConfig_1.outs;
    }
    static get in() {
        return FilterConfig_1.ins[0];
    }
    static get out() {
        return FilterConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.FILTER.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.CLEAN], this.ins, this.outs, ['where', 'restrict', 'remove'], true);
    }
    // not actually used in getoutput/valid; we pass parameters into colarguments+isvalid
    applyParameters(parameters) {
        return new FilterConfig_1(this.filter.applyParameters(parameters));
    }
    getBaseValues(parameters) {
        return { filter: this.filter.getBaseValues(parameters) };
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        if (source) {
            const exp = tsb.export(this.out);
            const filtCols = this.filter.getColumnArguments(iConfigHelper.getParameters());
            const dependents = this.getDependents(exp, this.in, Array.from(filtCols));
            source.forEach((c) => {
                if (filtCols.has(c.name))
                    exp.copy(this.in, c, true, true, dependents, undefined);
                else
                    exp.copy(this.in, c, false, false);
            });
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, ins) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, ins);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        if (!this.filter.isValid(iConfigHelper.getParameters(), source)) {
            return ToolValidationResult.getBadMetadataResult('One or more filters are invalid.');
        }
        return ToolValidationResult.getValidResult();
    }
};
FilterConfig = FilterConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.FILTER)
], FilterConfig);
export { FilterConfig };
//# sourceMappingURL=filterConfig.js.map